import React from 'react';

import { PickupStoreSelector } from 'features/store/pages/pickup-store-selector';
import { StyleSheet } from 'react-native';

import Modal from 'components/modal';
import { Box } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

/**
 *
 * StoreSelectorModal
 * This component is a wrapper for the PickupStoreSelector component.
 * It is used to easily select a store and fill the form with the store details.
 * it is used when pypestream is disabled and the user is in the support form.
 */
export const StoreSelectorModal: React.FC<React.PropsWithChildren<{
  onDismiss: () => void;
  onStoreSelect: (storeId: string) => Promise<void>;
}>> = ({ onDismiss, onStoreSelect }) => {
  const handleSelectStore = (storeId: string) => {
    onStoreSelect(storeId);
    onDismiss();
  };

  return (
    <Modal
      amplitudeEventData={{ modalAppearanceEventMessage: 'Store Locator Modal' }}
      onDismiss={onDismiss}
      // Disable scrolling allows us to move only the list while keeping other elements fixed.
      withScroll={false}
      allowsDismiss
      header={t('selectLocation')}
    >
      <Box style={styles.modalContent} testID="support-form-v2-store-selector-refresh">
        <PickupStoreSelector
          onDismissInSupportForm={onDismiss}
          isInSupportForm
          onSelectStore={handleSelectStore}
        />
      </Box>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContent: {
    width: '100%',
    backgroundColor: primitive.$mayoEggWhite,
    height: '100%',
  },
});
